import React, { useEffect } from "react"
import styled from "styled-components"
import InputSwitch from "@src/components/reusable/forms/input-switch"
import InputDropdown from "@src/components/reusable/forms/input-dropdown-v2"
import InputNumber from "@src/components/reusable/forms/input-number"
import { useFormContext } from "react-hook-form"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.gray200};
  padding-bottom: 40px;
  padding-top: 40px;

  @media (max-width: 660px) {
    flex-direction: column;
    gap: 24px;
  }
`

const Title = styled.div`
  color: ${props => props.theme.gray900};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  @media (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`

const Column = styled.div`
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 660px) {
    width: 100%;
    gap: 24px;
  }
`

const ColumnMain = styled.div`
  width: 69%;
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 660px) {
    width: 100%;
    gap: 24px;
  }
`

const ColumnPushed = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 64px;
  width: 100%;
  gap: 16px;
  .input-number {
    width: 100%;
    max-width: 390px;
  }
  @media (max-width: 500px) {
    padding: 0;
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  .input-dropdown {
    width: 100%;
    max-width: 390px;
  }
`

const Location = styled.div`
  margin-top: 28px;
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-wrap: nowrap;
`

const OptionsExtras = ({ optionalExtras = [], setExtras }) => {
  // Extras Count
  const { watch } = useFormContext()
  const switchFieldPaths = optionalExtras.map(
    extra => `extras.${extra.key}.enabled`,
  )
  const watchedSwitches = watch(switchFieldPaths)

  useEffect(() => {
    if (!watchedSwitches) return

    const count = watchedSwitches.filter(val => val === true).length
    setExtras(count)
  }, [watchedSwitches, setExtras])

  // Render function
  const renderExtra = extra => {
    const { key, label, options, nights_field } = extra
    const base = `extras.${key}`

    return (
      <Column key={key}>
        <InputSwitch name={`${base}.enabled`} label={label} />
        {/* To fix later when we expand offering */}
        {options && (
          <ColumnPushed>
            <Row>
              <InputDropdown
                name={`${base}.from_destination`}
                label="From"
                options={options.from}
                placeholder="Select an option"
              />
              <Location>{options.from}</Location>
            </Row>
            <Row>
              <InputDropdown
                name={`${base}.to_destination`}
                label="To"
                options={options.to}
                placeholder="Select an option"
              />
              <Location>{options.to}</Location>
            </Row>
          </ColumnPushed>
        )}
        {/* To fix later when we expand offering */}
        {nights_field && (
          <ColumnPushed>
            <InputNumber
              label="Nights"
              name={`${base}.${nights_field}`}
              min={0}
              max={365}
              required={false}
              defaultValue={0}
            />
          </ColumnPushed>
        )}
      </Column>
    )
  }

  return (
    <Wrapper>
      <Title>Optional Extras</Title>
      <ColumnMain>{optionalExtras.map(renderExtra)}</ColumnMain>
    </Wrapper>
  )
}

export default OptionsExtras
